import * as THREE from 'three'

export default function createWall({ scene })
{
  const wall = new THREE.Mesh(
    new THREE.PlaneGeometry(10, 10, 10),
    new THREE.MeshStandardMaterial({ color: '#aaaaaa' })
  )

  wall.receiveShadow = true

  wall.position.x = -4
  wall.position.y = -3
  wall.position.z = -4

  wall.lookAt(new THREE.Vector3(0, 0, 0))

  scene.add(wall)

  return wall
}
